module.exports = "/static/Images/en/Satisfied.png";